import { Box, Typography, Button, Fade } from "@mui/material";
import { useState } from "react";

const PRIMARY_COLOR = "#FF770D";

const UpgradeStickyBanner = ({ planActual, planDestino, modulo, onClickUpgrade }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{ position: "relative", width: "100%" }}
    >
      {/* Banner superior */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 5,
          background: "#fffaf3",
          borderBottom: "1px solid #ffe0c1",
          py: 1,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body2" sx={{ color: "#7a5400", fontWeight: 500 }}>
          Estás usando el plan <b>{planActual}</b>. El módulo {modulo} completo está en el plan <b>{planDestino}</b>.
        </Typography>
        <Button
          size="small"
          variant="contained"
          onClick={onClickUpgrade}
          sx={{
            backgroundColor: PRIMARY_COLOR,
            "&:hover": { backgroundColor: "#e65e00" },
            textTransform: "none",
            color: "#fff",
          }}
        >
          Conocer beneficios
        </Button>
      </Box>

      {/* Box lateral animado con Fade */}
      <Fade in={isHovered} timeout={300}>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 43,
            width: 300,
            background: "#ffffffee",
            borderRadius: 2,
            boxShadow: 6,
            p: 2,
            zIndex: 10,
          }}
        >
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Lleva tus {modulo.toUpperCase()} al siguiente nivel 🚀
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Filtrado ilimitado, exportaciones, página web para clientes, y más.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => window.open("https://wa.me/59177142692", "_blank")}
            sx={{
              backgroundColor: PRIMARY_COLOR,
              "&:hover": { backgroundColor: "#e65e00" },
              textTransform: "none",
              color: "#fff",
            }}
          >
            Obtener plan {planDestino}
          </Button>
        </Box>
      </Fade>
    </Box>
  );
};

export default UpgradeStickyBanner;
